import React from 'react';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import routes from '../../config/settings/routes';
import { HeaderMenuItem, HeaderNavigation, HeaderMenu } from '@carbon/react';
import "./ManagementMenu.styles.scss"

/**
 * The ManagementMenu's component
 * 
 * To disable a HeaderMenuItem, wrap it aroud this component
 * `<div className='div-disabled'><HeaderMenuItem .../></div>`
 * and apply a className to it
 * `<HeaderMenuItem className='disabled' />`.
 */
export const ManagementMenu = props => {
  const { current } = props;

  const isToolHeaderActive =
    current === routes.map;

  return (
    <HeaderNavigation aria-label="Talabre">
      <HeaderMenu
        aria-label="Mapa"
        menuLinkName="Mapa"
        isActive={isToolHeaderActive}
      >
        <HeaderMenuItem as={Link} to={routes.map}>
          Mapa
        </HeaderMenuItem>
      </HeaderMenu>
      <HeaderMenu
        aria-label="Dashboard CAN"
        menuLinkName="Dashboard CAN"
        isActive={current === routes.can}
      >
        <HeaderMenuItem as={Link} to={routes.canDashboard}>
          Dashboard CAN
        </HeaderMenuItem>
      </HeaderMenu>
      <HeaderMenu
        aria-label="Ciclos"
        menuLinkName="Ciclos"
        isActive={current === routes.cycles}
      >
        <HeaderMenuItem as={Link} to={routes.cyclesCycles}>
          Ciclos
        </HeaderMenuItem>
      </HeaderMenu>
      <HeaderMenu
        aria-label="Disponibilidad y utilización"
        menuLinkName="Disponibilidad y utilización"
        isActive={current === routes.times}
      >
        <HeaderMenuItem as={Link} to={routes.timesTimes}>
          Disponibilidad y utilización
        </HeaderMenuItem>
      </HeaderMenu>
      {/* <HeaderMenu
        aria-label="Ordenes de Trabajo"
        menuLinkName="Ordenes de Trabajo"
        isActive={current === routes.orders}
      >
        <HeaderMenuItem as={Link} to={routes.ordersOrder}>
          Ordenes de trabajo
        </HeaderMenuItem>
      </HeaderMenu>
      <HeaderMenu
        aria-label="Reportes"
        menuLinkName="Reportes"
        isActive={current === routes.reports}
      >
        <HeaderMenuItem as={Link} to={routes.reportsReport}>
          Reportes
        </HeaderMenuItem>
      </HeaderMenu> */}
      <HeaderMenu
        aria-label="Vista Individual de Movimientos Recientes"
        menuLinkName="Vista Individual de Movimientos Recientes"
        isActive={current === routes.huella}
      >
        <HeaderMenuItem as={Link} to={routes.huellaDashboard}>
          Vista Individual de Movimientos Recientes
        </HeaderMenuItem>
        <HeaderMenuItem as={Link} to={routes.huellaRalenti}>
          Eventos de ralentí
        </HeaderMenuItem>
      </HeaderMenu>
      <HeaderMenu
        aria-label="Vista Consolidada de movimientos Históricos"
        menuLinkName="Vista Consolidada de movimientos Históricos"
        isActive={current === routes.kepler}
      >
        <HeaderMenuItem as={Link} to={routes.kepler}>
          Vista Consolidada de movimientos Históricos
        </HeaderMenuItem>
      </HeaderMenu>
    </HeaderNavigation>
  )
}

ManagementMenu.propTypes = {
  current: PropTypes.string.isRequired
}

export default ManagementMenu
